import React from 'react';
import { InjectedIntlProps, injectIntl, MessageValue } from 'react-intl';
import { TLCode } from '../../common/enums';
import hoistNonReactStatics from 'hoist-non-react-statics';

// import getDisplayName from 'react-display-name';

export interface WithTranslateProps {
  translate: Translate;
}

export type Translate = (code: TLCode, values?: { [key: string]: MessageValue }) => string;

const withTranslate = (WrappedComponent) => {
  class WithTranslate extends React.Component<InjectedIntlProps> {
    // static displayName = `withTranslation(${getDisplayName(WrappedComponent)})`;

    translate: Translate = (code, values) => {
      return this.props.intl.formatMessage({ id: TLCode[code] }, values);
    };

    render() {
      return <WrappedComponent translate={this.translate} {...this.props} />;
    }
  }

  hoistNonReactStatics(WithTranslate, WrappedComponent);

  return injectIntl<any>(WithTranslate);
};

export default withTranslate;
